import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../utils/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { unescape } from "querystring";
import { AMENITIES } from './hotel';
import { NgxGalleryOptions } from 'ngx-gallery';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ParameterService } from '../../../utils/services/parameter.service';
import { NotificationsService } from 'angular2-notifications';
const H = window['H'];

@Component({
  selector: 'app-hotel-detail',
  templateUrl: './hotel-detail.component.html',
  styleUrls: ['./hotel-detail.component.scss']
})
export class HotelDetailComponent implements OnInit {

  hotelId;
  hotelInfo;
  orgHotels = [];
  hotelServices = AMENITIES;
  hotelServiceModel;
  imagesToUpload = [];
  galleryImages = [];
  galleryOptions: NgxGalleryOptions[];
  statuses = [
    {
      key: 'Active',
      value: 'Active'
    },
    {
      key: 'PendingConfirmation',
      value: 'Pending Confirmation'
    },
    {
      key: 'Decline',
      value: 'Decline'
    },
    {
      key: 'Inactive',
      value: 'Inactive'
    },
    {
      key: 'New',
      value: 'New'
    }
  ];
  orgHotelStatuses = [
    {
      key: 'Active',
      value: 'Active'
    },
    {
      key: 'Inactive',
      value: 'Inactive'
    }
  ];
  hotelCities: Observable<Array<any>>
  countryCode="TR";
  isLoading = true;
  constructor(private api: ApiService, private param: ParameterService,
    private active: ActivatedRoute, private http: HttpClient, private notification: NotificationsService) {
    this.hotelId = this.active.snapshot.params.id;
    this.galleryOptions = [
      {
        width: '100%',
        height: '400px',
        thumbnailsColumns: 4,
        actions: [{
          icon: '',
          onClick: (event) => {
            console.log(event);
          }
        }],
        imageActions: [{
          icon: 'fa fa-trash',
          disabled: false,
          onClick: (event) => {
            let url = event.target['offsetParent'].offsetParent.style.backgroundImage.toString().replace('url("', '').replace('")', '');
            this.api.deleteBiziHotelInfoImage(this.hotelInfo.id, { body: { imgUrl: url } }).subscribe(res => {
              this.galleryImages = this.galleryImages.filter(p => p.big !== url);
              this.notification.success('Done!')
            }, err => {
              this.notification.alert(err.error.message)
            })
          }
        }]
      }
    ];
    this.hotelServiceModel = this.hotelServices.map(p => {
      return {
        display: p,
        value: false
      }
    })
   

  }

  fethCities() {
    this.param.getCities('countryCode_Eq='+this.countryCode+'&type_Eq=City').subscribe(res => {
      this.hotelCities = res.data;
    })
  }
  ngOnInit() {
    this.api.getHotelById(this.hotelId).subscribe(res => {
      this.hotelInfo = res.data;
      if(!this.hotelInfo.description || this.hotelInfo.description.length == 0) {
        this.hotelInfo.description = [
          {type: "short", description: ""},
          {type: "full", description: ""},
          {type: "location", description: ""}
        ];
      } else {
        let shortDesc = this.hotelInfo.description.find(item => item.type == "short");
        let fullDesc = this.hotelInfo.description.find(item => item.type == "full");
        let locationDesc = this.hotelInfo.description.find(item => item.type == "location");
        if(!shortDesc) {
          this.hotelInfo.description.push({type: "short", description: ""});
        }
        if(!fullDesc) {
          this.hotelInfo.description.push({type: "full", description: ""});
        }
        if(!locationDesc) {
          this.hotelInfo.description.push({type: "location", description: ""});
        }
      }
      this.countryCode = this.hotelInfo.countryIso
      this.fethCities();

      this.hotelServiceModel = this.hotelServiceModel.map(p => {
        res.data.info.services.forEach(item => {
          if (p.display === item) {
            p.value = true;
          }
        });
        return p;
      })
      this.hotelInfo.info.images.forEach(image => {
        let img = new Image();
        img.src = image;
        img.onload = (e) => {
          if (e['path'] && e['path'].length > 0 && e['path'][0].width > 500) {
            this.galleryImages.push({
              small: image,
              medium: image,
              big: image
            });
          }
        }
        console.log(this.galleryImages);
      });
    });

    this.api.getHotelOrganizationHotelsByHotelId(this.hotelId).subscribe(hotelRes => {
      let requests = [];
      let orgIds = Array.from(new Set(hotelRes.data.map(p => p.organizationId)))
      orgIds.forEach(orgId => {
        requests.push(this.api.getOrganizationByID(orgId));
      });
      this.orgHotels = [];
      Observable.forkJoin(requests).subscribe(res => {
        hotelRes.data.forEach(orgHotelItem => {
          let orgData = res.find(item => item['data']['id'] === orgHotelItem.organizationId)['data'];
          orgHotelItem['organization'] = orgData;
          orgHotelItem.agencyMail = orgHotelItem.actionJson.notification[0] ? orgHotelItem.actionJson.notification[0].data.to.toString(): null;
          orgHotelItem.hotelMail = orgHotelItem.actionJson.confirmation[0] ? orgHotelItem.actionJson.confirmation[0].data.to.toString() : null;
          orgHotelItem.isSentConfirmMail = orgHotelItem.actionJson.confirmation[0] ? orgHotelItem.actionJson.confirmation[0].options.isSendPurchaseConfirmation : null;
          this.orgHotels.push(orgHotelItem);
        });
        this.isLoading = false;
      })
      this.isLoading = false;
    }, err => {
      this.isLoading = false;

    });
  }

  onMultipleFilesUploaded(event) {
    let imageList = event.target.files;
    let readOperations = [];
    if (imageList) {
      for (let file of imageList) {
        readOperations.push(this.readFile(file));
      }
    }
    Observable.forkJoin(readOperations).subscribe(readResponse => {
      this.imagesToUpload = [...this.imagesToUpload, ...readResponse];
    }, error => {
    })
  }

  onImageSelect(event) {
    this.readFile(event.target.files[0]).subscribe(res => {
      this.hotelInfo.imageData = res;
    });
  }

  readFile(file): Observable<any> {
    let reader = new FileReader();
    reader.readAsDataURL(file);

    return Observable.create((observer: any) => {
      reader.onload = (event) => {
        observer.next({
          url: reader.result,
          name: file.name,
          fileType: file.type,
          loaded: true,
          selected: false,
          data: this.dataURItoBlob(reader.result)
        })
        observer.complete()
      }
    });
  }

  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString = dataURI;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else
      byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  @ViewChild('hereMapContainer') mapContainer;

  onCitySelected(event) {
    console.log(event);
    this.param.getCities(`id_Eq=${event.item.cityId}&Type_Eq=City`).subscribe(res => {
      if(res.data && res.data.length > 0) {
        this.hotelInfo.cityId = res.data[0].id;
        if(this.countryCode != res.data[0].countryCode) {
          this.countryCode = res.data[0].countryCode;
          this.fethCities();
        }
      } else {
        this.hotelInfo.cityId = null;
        this.notification.warn("Warning", "Please select a city!");
      }
    }, err => {
        this.hotelInfo.cityId = null;
        this.notification.warn("Warning", "Please select a city!");
    })
    this.hotelInfo.address = event.item.rawDesc;
    this.hotelInfo.countryIso = event.item.countryCode;
    this.hotelInfo.latitude = event.item.position.lat;
    this.hotelInfo.longitude = event.item.position.lng;
   

    this.mapContainer.hereMap.getObjects().filter(p => p instanceof H.map.Marker).forEach(item => {
      item.setVisibility(false);
    })
    this.mapContainer.hereMap.setCenter({ lat: event.item.position.lat, lng: event.item.position.lng });
    var defaultMarker = new H.map.Marker({ lat: event.item.position.lat, lng: event.item.position.lng });
    this.mapContainer.hereMap.addObject(defaultMarker);
    this.mapContainer.hereMap.setZoom(14);
  }

  applyStatus() {
    this.isLoading = true;
    this.api.updateHotelStatus(this.hotelInfo.id, { status: this.hotelInfo.status }).subscribe(res => {
      this.isLoading = false;
      this.notification.success('Status Change Done!')
    }, err => {
      this.isLoading = false;
      this.notification.alert(err.error.message)
    })
  }


  updateBiziHotelGeneralInfo() {
    let postData = {
      "name": this.hotelInfo.name,
      "stars": this.hotelInfo.stars,
      'email': this.hotelInfo.email,
      "description": this.hotelInfo.description,
      "contactNumbers": this.hotelInfo.contactNumbers
    }
    this.isLoading = true;
    if (this.hotelInfo.imageData) {
      this.api.updateBiziHotelGeneralInfo(this.hotelInfo.id, postData).switchMap(res => {
        return this.addBiziHotelMainImage(this.hotelInfo.imageData)
      }).subscribe(res => {
        this.isLoading = false;
        this.notification.success('Done!')
      }, error => {
        this.notification.alert(error.error.message)
        this.isLoading = false;
      });
    } else {
      this.api.updateBiziHotelGeneralInfo(this.hotelInfo.id, postData).subscribe(res => {
        this.isLoading = false;
        this.notification.success('Done!')
      }, error => {
        this.notification.alert(error.error.message)
        this.isLoading = false;
      });
    }
  }

  addBiziHotelMainImage(isUpdateOperation?) {
    let imageUrl = null;
    let fileToUpload = { name: this.hotelInfo.imageData.name, fileType: this.hotelInfo.imageData.fileType };
    return this.api.addBiziHotelImage(this.hotelInfo.id, fileToUpload)
      .switchMap(apiRes => {
        imageUrl = apiRes.data.signedUrl.split("?")[0]
        return this.uploadSignedImage(apiRes, this.hotelInfo.imageData)
      }).switchMap(res => {
        this.hotelInfo.image = imageUrl;
        return this.api.updateBiziHotelImage(this.hotelInfo.id, { image: this.hotelInfo.image });
      }).catch(error => {
        return Observable.of(null);
      });
  }

  updateBiziHotelLocationInfo() {
    let postData = {
      "cityId": this.hotelInfo.cityId,
      "countryIso": this.hotelInfo.countryIso,
      "latitude": this.hotelInfo.latitude,
      "longitude": this.hotelInfo.longitude,
      "address": this.hotelInfo.address
    }
    this.isLoading = true;
    this.api.updateBiziHotelLocationInfo(this.hotelInfo.id, postData).subscribe(res => {
      this.isLoading = false;
      this.notification.success('Done!')
    }, error => {
      this.isLoading = false;
      this.notification.alert(error.error.message)
    });
  }

  updateBiziHotelServicesInfo() {
    if (this.hotelInfo.id) {
      this.isLoading = true;
      let services = this.hotelServiceModel.filter(p => p.value).map(p => p.display);
      this.api.updateBiziHotelServicesInfo(this.hotelInfo.id, { services }).subscribe(res => {
        this.isLoading = false;
        this.notification.success('Done!');
      }, error => {
        this.isLoading = false;
        this.notification.alert(error.error.message);
      });
    }
  }

  toggleUploadImage(event) {
    this.imagesToUpload[event.index].selected = !this.imagesToUpload[event.index].selected;
  }

  removeAllSelectionsToUpload() {
    this.imagesToUpload.forEach(item => item.selected = false);
  }

  deleteSelectedUploadImages() {
    this.imagesToUpload = this.imagesToUpload.filter(item => !item.selected);
  }

  uploadImages() {

    let multiUploadObs = this.startMultipleUploadOperation();
    Observable.forkJoin(multiUploadObs).switchMap(res => {
      return this.api.getBiziHotelInfoImages(this.hotelInfo.id)
    }).subscribe(res => {
      this.galleryImages = [];
      res.data.images.forEach(image => {
        let img = new Image();
        img.src = image;
        img.onload = (e) => {
          if (e['path'] && e['path'].length > 0 && e['path'][0].width > 500) {
            this.galleryImages.push({
              small: image,
              medium: image,
              big: image
            });
          }
        }
        this.imagesToUpload = [];
        console.log(this.galleryImages);
      });
    })

  }

  startMultipleUploadOperation(): Observable<any>[] {
    let requests = []
    if (this.imagesToUpload.length > 0) {
      this.imagesToUpload.forEach(item => requests.push(this.addBiziHotelInfoImage(item)));
    }
    return requests;
  }

  addBiziHotelInfoImage(file) {
    let infoImageUrls = [];
    return this.api.addBiziHotelImage(this.hotelInfo.id, { name: file.name, fileType: file.fileType }).switchMap(apiRes => {
      let url = apiRes.data.signedUrl.split("?")[0];
      infoImageUrls.push(url);
      this.hotelInfo.info.images.push(url);
      return this.uploadSignedImage(apiRes, file)
    }).switchMap(httpPutRes => {
      return this.api.updateBiziHotelInfoImages(this.hotelInfo.id, { images: infoImageUrls });
    })
      .catch(error => {
        return Observable.of(error);
      });
  }

  uploadSignedImage(response, imageFile, isUpdateOperation = false) {
    var signedUrl = response.data.signedUrl;
    const headerDict = {
      'Content-Type': imageFile.fileType
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.put(signedUrl, imageFile.data, requestOptions);
  }

  onSubmit(orgHotel) {
    let postData = {
      'accountingNumber': orgHotel.accountingNumber,
      "email": orgHotel.hotelMail,
      "isSentConfirmMail": !!orgHotel.isSentConfirmMail,
      "isSentRefundConfirmation": false,
      "notificationMail": orgHotel.agencyMail ? orgHotel.agencyMail.split(',') : [],
      'hotelSpecId': this.hotelInfo.hotelId,
      'id': orgHotel.id,
      organizationId: orgHotel.organizationId,
      status: orgHotel.status
    }
    this.isLoading = true;
    this.api.updateOrganizationHotel(postData.id, postData).subscribe(res => {
      this.isLoading = false;
      this.notification.success('Done!')
    }, err => {
      this.notification.alert(err.error.message)
      this.isLoading = false;
    })
    console.log(postData);
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/hotel-detail/hotel-detail.component.ts